<template>
  <div class="btn-group" :class="{ 'dropup': dropup, 'btn-group-sm': isSmall }">
    <button type="button" class="btn dropdown-toggle dropup" :class="buttonClass"
    @click="dropdown('dropdown')">
      <span class="fa" :class="labelIcon"></span>
      {{ label }} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu" ref="dropdown" :class="{ 'dropdown-menu-right': dropright }">
      <template v-for="(action, i) in actions">
        <template v-if="action.labelOnly">
          <li :key="i" class="dropdown-item">
            <a>
              <span class="fa-fw" :class="action.icon"></span>
              {{ action.label }}
            </a>
          </li>
        </template>
        <template v-else>
          <li :key="i" class="dropdown-item" @click="$emit('action', action.command)">
            <a>
              <span class="fa-fw" :class="action.icon"></span>
              {{ action.label }}
            </a>
          </li>
        </template>
        <li :key="i + '-divider'" role="separator" class="dropdown-divider border-default" v-if="i < actions.length - 1"></li>
      </template>
    </ul>
  </div>
</template>

<script>
import dom from '@/util/dom'
export default {
  name: 'DropdownInput',
  props: {
    isSmall: {
      type: Boolean,
      default () {
        return false
      }
    },
    dropup: {
      type: Boolean,
      default () {
        return false
      }
    },
    dropright: {
      type: Boolean,
      default () {
        return false
      }
    },
    label: {
      type: String
    },
    labelIcon: {
      type: String
    },
    actions: {
      type: Array
    },
    buttonClass: {
      type: String,
      default () {
        return 'btn-primary'
      }
    }
  },
  methods: {
    dropdown (ref) {
      dom(this).dropdown(ref)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DropdownInput.vue